var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSettings = function SvgSettings(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#212C3D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.361 1.861L2.361.022 1.541.022 1.541 1.861 0 1.861 0 5.068 1.541 5.068 1.541 12.721 2.361 12.721 2.361 5.068 3.902 5.068 3.902 1.861zM7.41 5.686L7.41.022 6.59.022 6.59 5.686 5.049 5.686 5.049 8.893 6.59 8.893 6.59 12.721 7.41 12.721 7.41 8.893 8.951 8.893 8.951 5.686zM12.459 1.861L12.459.022 11.639.022 11.639 1.861 10.098 1.861 10.098 5.068 11.639 5.068 11.639 12.721 12.459 12.721 12.459 5.068 14 5.068 14 1.861z",
    transform: "translate(5 6)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSettings, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/settings.d6c31204.svg";
export { ForwardRef as ReactComponent };